module.exports = __webpack_public_path__ + "fonts/brandon_med-webfont.4f454ad0097f9f04c5a28d5a7dec6271.ttf";